// Operator constants + display labels — Polish B2.
//
// The set is intentionally small. The backend validator + compiler
// know about ``eq``/``neq``/``in``/``nin``/``lt``/``lte``/``gt``/``gte``/
// ``contains``/``is_null``/``is_not_null``; the UI exposes a smaller
// vocabulary specific to each field type, so e.g. dates expose
// ``is_on``/``is_before``/``is_after`` (mapped onto eq/lt/gt) while
// status uses ``is``/``is_not`` (mapped onto eq/in/nin).

export type WireOperator =
  | "eq" | "neq" | "in" | "nin"
  | "lt" | "lte" | "gt" | "gte"
  | "contains" | "is_null" | "is_not_null";


export type UiOperator =
  // Single-value fields (priority, complexity, regulatory)
  | "is" | "is_not"
  // Multi-select fields (status, assignee, tags, …) collapse to
  // ``is`` + multi-value (wire ``in``) and ``is_not`` (wire ``nin``).
  // Date relational ops surface as their own UI labels.
  | "is_on"
  | "is_before"
  | "is_before_or_on"
  | "is_after"
  | "is_after_or_on"
  // Free text
  | "contains"
  // Presence
  | "is_empty"
  | "is_not_empty";


export const OPERATOR_LABELS: Record<UiOperator, string> = {
  is: "Is",
  is_not: "Is not",
  is_on: "Is on",
  is_before: "Is before",
  is_before_or_on: "Is on or before",
  is_after: "Is after",
  is_after_or_on: "Is on or after",
  contains: "Contains",
  is_empty: "Is empty",
  is_not_empty: "Is not empty",
};
